const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentAccordion extends HTMLDivElement {

    constructor() {
        super();
        this.initialize = this.initialize.bind(this);
    }

    async connectedCallback() {
        await childrenLoaded(this);
        this.initialize();
    }

    initialize() {
        if (this.initialized) {
            return;
        }

        // 1. Initialize AceAccordion first so it finishes its internal setup
        this.initializeAccordion();

        // 2. Force the first item open AFTER AceAccordion is done setting up
        this.handleOpenFirstDefault();

        // 3. Set up click trackers for user interaction only
        this.handleHashManagement();   
        this.handleInitialDeepLink();

        this.initialized = true;
    }

    initializeAccordion() {
        this.accordionInstance = new AceAccordion ({
            selectors: {
                accordion: '.component-accordion__items',
                item: '.component-accordion__item',
                heading: '.component-accordion__item-heading',
                content: '.component-accordion__item-content',
                content_inner: '.component-accordion__item-content-inner'
            }
        });
    }

    handleOpenFirstDefault() {
        const itemsContainer = this.querySelector('.component-accordion__items');
        const shouldOpenFirst = itemsContainer && itemsContainer.getAttribute('data-open-first') === 'true';
        
        if (shouldOpenFirst && !window.location.hash) {
            const firstItem = this.querySelector('.component-accordion__item');
            
            if (firstItem) {
                // A 0ms timeout pushes this execution to the next event loop tick, 
                // ensuring AceAccordion is 100% finished mounting before we make changes.
                setTimeout(() => {
                    firstItem.setAttribute('data-ace-item-state', 'opened');
                    
                    const firstHeading = firstItem.querySelector('.component-accordion__item-heading');
                    if (firstHeading) {
                        firstHeading.setAttribute('aria-expanded', 'true');
                    }

                    const firstContent = firstItem.querySelector('.component-accordion__item-content');
                    if (firstContent) {
                        firstContent.setAttribute('aria-hidden', 'false');
                        firstContent.style.height = 'auto'; 
                        firstContent.style.display = 'block';
                    }

                    // Force CSS open class
                    firstItem.classList.add('is-open');
                }, 0);
            }
        }
    }

    handleHashManagement() {
        const headings = this.querySelectorAll('.component-accordion__item-heading');
        
        headings.forEach(heading => {
            heading.addEventListener('click', () => {
                setTimeout(() => {
                    const item = heading.closest('.component-accordion__item');
                    const slug = heading.getAttribute('data-slug');
                    
                    const isOpen = item.classList.contains('is-open') || 
                                   heading.getAttribute('aria-expanded') === 'true' || 
                                   item.getAttribute('data-ace-item-state') === 'opened';

                    if (isOpen) {
                        window.history.pushState(null, null, `#${slug}`);
                    } else {
                        if (window.location.hash === `#${slug}`) {
                            this.updateHashForRemainingOpenItems();
                        }
                    }
                }, 50); 
            });
        });
    }

    updateHashForRemainingOpenItems() {
        const remainingOpenHeading = Array.from(this.querySelectorAll('.component-accordion__item-heading')).find(heading => {
            const item = heading.closest('.component-accordion__item');
            return item.classList.contains('is-open') || heading.getAttribute('aria-expanded') === 'true' || item.getAttribute('data-ace-item-state') === 'opened';
        });

        if (remainingOpenHeading) {
            const nextSlug = remainingOpenHeading.getAttribute('data-slug');
            window.history.pushState(null, null, `#${nextSlug}`);
        } else {
            window.history.pushState(null, null, window.location.pathname + window.location.search);
        }
    }

    handleInitialDeepLink() {
        const currentHash = window.location.hash.replace('#', '');
        if (!currentHash) return;

        const targetHeading = this.querySelector(`.component-accordion__item-heading[data-slug="${currentHash}"]`);
        
        if (targetHeading) {
            setTimeout(() => {
                targetHeading.click();
                const item = targetHeading.closest('.component-accordion__item');
                if (item) {
                    item.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }
    }
}

customElements.define('component-accordion', ComponentAccordion, {extends: 'div'});